/**
 * Hub Medical
 * Hub medical Consorcio
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProfileProviderPJ } from './profileProviderPJ';
import { UserRef } from './userRef';


export interface ProviderPJUser { 
    id?: number;
    role?: ProviderPJUser.RoleEnum;
    profileProviderPJ?: ProfileProviderPJ;
    user?: UserRef;
}
export namespace ProviderPJUser {
    export type RoleEnum = 'OWNER' | 'LEADER' | 'MEMBER';
    export const RoleEnum = {
        Owner: 'OWNER' as RoleEnum,
        Leader: 'LEADER' as RoleEnum,
        Member: 'MEMBER' as RoleEnum
    };
}


